/**
 * Visibilidad del asterisco de obligatorio en custom fields.
 * Debe permanecer visible mientras el campo sea required, aunque ya tenga valor.
 */
export function showRequiredAsterisk(
  field: { required?: unknown } | null | undefined,
  extraRequired: unknown = false
): boolean {
  return !!(field?.required || extraRequired);
}
